import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "width", "height", "viewBox"]
const _hoisted_2 = ["d"]
const _hoisted_3 = ["transform", "data-id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "camera-marker__bucket",
  d: "\n                M32.3631 5\n                L7.63692 5\n                C6.31256 5 5.35391 6.26395 5.71099 7.53926\n                L11.591 28.5393\n                C11.8328 29.4029 12.62 30 13.5169 30\n                L26.4831 30\n                C27.38 30 28.1672 29.4029 28.409 28.5393\n                L34.289 7.53926\n                C34.6461 6.26395 33.6874 5 32.3631 5\n                Z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  class: "camera-marker__bucket-border",
  d: "\n                M32.3631 5\n                L7.63692 5\n                C6.31256 5 5.35391 6.26395 5.71099 7.53926\n                L11.591 28.5393\n                C11.8328 29.4029 12.62 30 13.5169 30\n                L26.4831 30C27.38 30 28.1672 29.4029 28.409 28.5393\n                L34.289 7.53926C34.6461 6.26395 33.6874 5 32.3631 5\n                Z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["data-id"]
const _hoisted_8 = ["cx", "cy"]
const _hoisted_9 = ["cx", "cy"]
const _hoisted_10 = ["data-id"]
const _hoisted_11 = ["cx", "cy"]
const _hoisted_12 = ["cx", "cy"]
const _hoisted_13 = ["data-id"]
const _hoisted_14 = ["cx", "cy"]
const _hoisted_15 = ["cx", "cy"]
const _hoisted_16 = ["width", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LIcon = _resolveComponent("LIcon")!
  const _component_LMarker = _resolveComponent("LMarker")!

  return (_openBlock(), _createBlock(_component_LMarker, {
    "lat-lng": _ctx.latLng,
    options: _ctx.options,
    draggable: !_ctx.disabled,
    onMousedown: _ctx.handleMouseDown,
    onReady: _ctx.setMarker,
    onDragend: _ctx.handleDragEnd
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LIcon, {
        "class-name": "camera-marker__icon-wrapper",
        "icon-anchor": _ctx.center
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("svg", {
            class: "camera-marker__icon",
            id: _ctx.markerId,
            style: _normalizeStyle(_ctx.iconSvgStyle),
            width: _ctx.size,
            height: _ctx.size,
            viewBox: `0 0 ${_ctx.size} ${_ctx.size}`
          }, [
            _createElementVNode("path", {
              class: "camera-marker__cone",
              d: _ctx.conePath
            }, null, 8, _hoisted_2),
            _createElementVNode("g", {
              transform: _ctx.bucketOffset,
              "data-id": _ctx.markerPartIds.bucket
            }, _hoisted_6, 8, _hoisted_3),
            _createElementVNode("g", {
              "data-id": _ctx.markerPartIds.left
            }, [
              _createElementVNode("circle", {
                cx: _ctx.anglePoints[0][0],
                cy: _ctx.anglePoints[0][1],
                r: "7",
                class: "camera-marker__dot-border"
              }, null, 8, _hoisted_8),
              _createElementVNode("circle", {
                cx: _ctx.anglePoints[0][0],
                cy: _ctx.anglePoints[0][1],
                r: "6",
                class: "camera-marker__dot camera-marker__control-angle_left"
              }, null, 8, _hoisted_9)
            ], 8, _hoisted_7),
            _createElementVNode("g", {
              "data-id": _ctx.markerPartIds.middle
            }, [
              _createElementVNode("circle", {
                cx: _ctx.middlePoint[0],
                cy: _ctx.middlePoint[1],
                r: "7",
                class: "camera-marker__dot-border"
              }, null, 8, _hoisted_11),
              _createElementVNode("circle", {
                cx: _ctx.middlePoint[0],
                cy: _ctx.middlePoint[1],
                r: "6",
                class: "camera-marker__dot camera-marker__control-rotation"
              }, null, 8, _hoisted_12)
            ], 8, _hoisted_10),
            _createElementVNode("g", {
              "data-id": _ctx.markerPartIds.right
            }, [
              _createElementVNode("circle", {
                cx: _ctx.anglePoints[1][0],
                cy: _ctx.anglePoints[1][1],
                r: "7",
                class: "camera-marker__dot-border"
              }, null, 8, _hoisted_14),
              _createElementVNode("circle", {
                cx: _ctx.anglePoints[1][0],
                cy: _ctx.anglePoints[1][1],
                r: "6",
                class: "camera-marker__dot camera-marker__control-angle_right"
              }, null, 8, _hoisted_15)
            ], 8, _hoisted_13),
            (_ctx.disabled)
              ? (_openBlock(), _createElementBlock("rect", {
                  key: 0,
                  class: "camera-marker__disable-overlay",
                  width: _ctx.size,
                  height: _ctx.size
                }, null, 8, _hoisted_16))
              : _createCommentVNode("", true)
          ], 12, _hoisted_1))
        ]),
        _: 1
      }, 8, ["icon-anchor"])
    ]),
    _: 1
  }, 8, ["lat-lng", "options", "draggable", "onMousedown", "onReady", "onDragend"]))
}